import { render, staticRenderFns } from "./LandlordFileUpload.vue?vue&type=template&id=0b5b0ea2&scoped=true"
import script from "./LandlordFileUpload.vue?vue&type=script&lang=js"
export * from "./LandlordFileUpload.vue?vue&type=script&lang=js"
import style0 from "./LandlordFileUpload.vue?vue&type=style&index=0&id=0b5b0ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b0ea2",
  null
  
)

export default component.exports